import * as React from 'react';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { NumberConvert, NumberCompareVP, MoneyLessBRL, MoneyFullBRL, NumberLessBRL } from 'src/services';

// tslint:disable-next-line:no-empty-interface
export interface ICardBigNumbersProps {
    conversionType: string,
    firstValue: null | string,
    loading: boolean,
    secondValue?: string,
    title: string,
}

// tslint:disable-next-line:no-empty-interface
export interface ICardBigNumbersState {
}

export class CardBigNumbers extends React.Component<ICardBigNumbersProps, ICardBigNumbersState> {

    constructor(props: ICardBigNumbersProps) {
        super(props);
    }

    public render() {

        /**
         * Caso a consulta não retorne o faturamento do ano anterior, nem o faturamento atual
         *      Não será calculado o percentual de divergência e a informação não será apresentada ao cliente
         */
        let percetDiference = null;
        if(this.props.secondValue != null && this.props.secondValue.length > 0 && parseFloat(this.props.secondValue).toFixed(0) !== "0" &&
        this.props.firstValue != null && this.props.firstValue.length > 0 && parseFloat(this.props.firstValue).toFixed(0) !== "0") {
            percetDiference = NumberCompareVP(
                NumberConvert(this.props.firstValue),
                NumberConvert(this.props.secondValue)
            );
        }

        let dataToShow = '';
        if(this.props.firstValue) {
            if(this.props.conversionType==='MoneyLessBRL') {
                dataToShow = MoneyLessBRL(this.props.firstValue);
            } else if (this.props.conversionType ==='MoneyFullBRL') {
                dataToShow = MoneyFullBRL(this.props.firstValue);
            } else if (this.props.conversionType ==='NumberLessBRL') {
                dataToShow = NumberLessBRL(this.props.firstValue);
            }
        }

        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="subheading" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {this.props.loading && <LinearProgress />}
                <Typography component="p" className="big-number">
                    {this.props.firstValue && dataToShow}
                </Typography>
                { percetDiference == null ? (
                            <Typography component="p" className="comparative transparent">
                                -
                            </Typography>
                        ) : percetDiference >= 0 ? (
                            <Typography component="p" className="comparative">
                                <span className="content-positive content-label" >
                                    {
                                        percetDiference.toFixed(1).replace(/\./g, ',')
                                    }% ano anterior
                                </span>
                            </Typography>
                        ) : (
                            <Typography component="p" className="comparative">
                                <span className="content-negative content-label" >
                                    {
                                        percetDiference.toFixed(1).replace(/\./g, ',')
                                    }% ano anterior
                                </span>
                            </Typography>
                        )
                }
            </Paper>
        )
    }
    
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/components/CardBigNumbers.tsx